<script setup>
    import { computed, ref } from 'vue'
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'
    import { SelectFieldSingle } from '@/js/components/Common'

    const props = defineProps({
        veranstaltungsOrt: {
            type: String,
            required: true
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() => (props.language === 'englisch' ? 'Campus | Veranstaltungsort' : 'Veranstaltungsort'))

    const emit = defineEmits(['veranstaltungsOrtSaved'])
    const veranstaltungsOrtOptions = [
        { title: 'Bernburg', value: 'Bernburg' },
        { title: 'Dessau', value: 'Dessau' },
        { title: 'Köthen/Papenburg', value: 'Köthen/Papenburg' },
        { title: 'Köthen', value: 'Köthen' }
    ]

    const allowEdit = computed(() => {
        return (
            store.getters['security/isAdmin'] ||
            store.getters['security/isStudienfachberater'] ||
            store.getters['security/isModulVerantwortlicher'] ||
            store.getters['security/isLehrender']
        )
    })

    let editOrt = ref('')

    function handleEditStart() {
        editOrt.value = props.veranstaltungsOrt
    }

    function handleEditAbort() {
        editOrt.value = ''
    }

    const saveVeranstaltungsOrt = () => {
        emit('veranstaltungsOrtSaved', editOrt.value)
    }
</script>

<template>
    <single-edit
        :entry="veranstaltungsOrt"
        edit-key="veranstaltungsort"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="saveVeranstaltungsOrt"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <select-field-single
                v-model="editOrt"
                :items="veranstaltungsOrtOptions"
                class="w-100 h-100"
                tile
                density="default"
            />
        </template>
    </single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
